/**
 * Projects & Reviews (`/projects`).
 *
 * The restructure merged the old Our Works page and the reviews section into
 * one page, so the work and the verdict on it sit together: videos, then
 * before-and-after, then completed jobs, then what customers actually said.
 * The reviews are the same live Google feed used on the homepage — proof
 * belongs on the page that shows the proof.
 */
import PageHero from "../components/PageHero";
import VideosSection from "../components/sections/VideosSection";
import BeforeAfterGallery from "../components/sections/BeforeAfterGallery";
import PhotoGallery from "../components/sections/PhotoGallery";
import GoogleReviews from "../components/sections/GoogleReviews";
import FinalCTA from "../components/sections/FinalCTA";

export default function OurWorks() {
  return (
    <>
      <PageHero
        eyebrow="Projects & Reviews"
        headline={"Real work.\nDocumented."}
        intro="A growing library of videos, before-and-after work and completed projects — alongside verified Google reviews from the customers behind them."
        image="/generated/service_deep_floor.png"
        imageAlt="Emilio's Solutions team machine-scrubbing a Singapore condo lobby floor"
      />
      <VideosSection />
      <BeforeAfterGallery />
      <PhotoGallery />
      <GoogleReviews />
      <FinalCTA />
    </>
  );
}
